webpackJsonp([35783957827783],{

/***/ 240:
/***/ (function(module, exports) {

	/*!
	 * for-in <https://github.com/jonschlinkert/for-in>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function forIn(obj, fn, thisArg) {
	  for (var key in obj) {
	    if (fn.call(thisArg, obj[key], key, obj) === false) {
	      break;
	    }
	  }
	};


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * for-own <https://github.com/jonschlinkert/for-own>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var forIn = __webpack_require__(240);
	var hasOwn = Object.prototype.hasOwnProperty;
	
	module.exports = function forOwn(obj, fn, thisArg) {
	  forIn(obj, function(val, key) {
	    if (hasOwn.call(obj, key)) {
	      return fn.call(thisArg, obj[key], key, obj);
	    }
	  });
	};


/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 255:
/***/ (function(module, exports) {

	/*!
	 * is-extendable <https://github.com/jonschlinkert/is-extendable>
	 *
	 * Copyright (c) 2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isExtendable(val) {
	  return typeof val !== 'undefined' && val !== null
	    && (typeof val === 'object' || typeof val === 'function');
	};


/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * object.omit <https://github.com/jonschlinkert/object.omit>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(255);
	var forOwn = __webpack_require__(241);
	
	module.exports = function omit(obj, keys) {
	  if (!isObject(obj)) return {};
	
	  keys = [].concat.apply([], [].slice.call(arguments, 1));
	  var last = keys[keys.length - 1];
	  var res = {}, fn;
	
	  if (typeof last === 'function') {
	    fn = keys.pop();
	  }
	
	  var isFunction = typeof fn === 'function';
	  if (!keys.length && !isFunction) {
	    return obj;
	  }
	
	  forOwn(obj, function(value, key) {
	    if (keys.indexOf(key) === -1) {
	
	      if (!isFunction) {
	        res[key] = value;
	      } else if (fn(value, key, obj)) {
	        res[key] = value;
	      }
	    }
	  });
	  return res;
	};


/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objectAssign = __webpack_require__(31);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _object = __webpack_require__(261);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _ElementRelativeCursorPosition = __webpack_require__(267);
	
	var _ElementRelativeCursorPosition2 = _interopRequireDefault(_ElementRelativeCursorPosition);
	
	var _addEventListener = __webpack_require__(268);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _constants = __webpack_require__(266);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _noop = __webpack_require__(269);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this.state = {
	            detectedEnvironment: {
	                isMouseDetected: false,
	                isTouchDetected: false
	            },
	            elementDimensions: {
	                width: 0,
	                height: 0
	            },
	            isActive: false,
	            isPositionOutside: true,
	            position: {
	                x: 0,
	                y: 0
	            }
	        };
	
	        _this.shouldGuardAgainstMouseEmulationByDevices = false;
	        _this.eventListeners = [];
	        _this.timers = [];
	        _this.elementOffset = {
	            x: 0,
	            y: 0
	        };
	
	        _this.onTouchStart = _this.onTouchStart.bind(_this);
	        _this.onTouchMove = _this.onTouchMove.bind(_this);
	        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
	        _this.onTouchCancel = _this.onTouchCancel.bind(_this);
	        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	        _this.onMouseMove = _this.onMouseMove.bind(_this);
	        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'onTouchStart',
	        value: function onTouchStart(e) {
	            this.init();
	            this.onTouchDetected();
	            this.setShouldGuardAgainstMouseEmulationByDevices();
	
	            var position = this.core.getCursorPosition(this.getTouchEvent(e));
	            this.setPositionState(position);
	
	            if (this.props.isActivatedOnTouch) {
	                e.preventDefault();
	                this.activate();
	                return;
	            }
	
	            this.initPressEventCriteria(position);
	            this.setPressEventTimer();
	        }
	    }, {
	        key: 'onTouchMove',
	        value: function onTouchMove(e) {
	            var position = this.core.getCursorPosition(this.getTouchEvent(e));
	
	            if (!this.state.isActive) {
	                this.setPressEventCriteria(position);
	                return;
	            }
	
	            this.setPositionState(position);
	            e.preventDefault();
	
	            if (this.props.shouldStopTouchMovePropagation) {
	                e.stopPropagation();
	            }
	        }
	    }, {
	        key: 'onTouchEnd',
	        value: function onTouchEnd() {
	            this.deactivate();
	            this.unsetShouldGuardAgainstMouseEmulationByDevices();
	        }
	    }, {
	        key: 'onTouchCancel',
	        value: function onTouchCancel() {
	            this.deactivate();
	            this.unsetShouldGuardAgainstMouseEmulationByDevices();
	        }
	    }, {
	        key: 'onMouseEnter',
	        value: function onMouseEnter(e) {
	            if (this.shouldGuardAgainstMouseEmulationByDevices) {
	                return;
	            }
	
	            this.init();
	            this.onMouseDetected();
	            this.setPositionState(this.core.getCursorPosition(e));
	            this.clearActivationTimers();
	            this.schedulActivation(this.props.hoverDelayInMs);
	        }
	    }, {
	        key: 'onMouseMove',
	        value: function onMouseMove(e) {
	            this.setPositionState(this.core.getCursorPosition(e));
	        }
	    }, {
	        key: 'onMouseLeave',
	        value: function onMouseLeave() {
	            this.clearActivationTimers();
	            this.scheduleDeactivation(this.props.hoverOffDelayInMs);
	            this.setState({ isPositionOutside: true });
	        }
	    }, {
	        key: 'onTouchDetected',
	        value: function onTouchDetected() {
	            var environment = {
	                isTouchDetected: true,
	                isMouseDetected: false
	            };
	
	            this.setState({ detectedEnvironment: environment });
	            this.props.onDetectedEnvironmentChanged(environment);
	        }
	    }, {
	        key: 'onMouseDetected',
	        value: function onMouseDetected() {
	            var environment = {
	                isTouchDetected: false,
	                isMouseDetected: true
	            };
	
	            this.setState({ detectedEnvironment: environment });
	            this.props.onDetectedEnvironmentChanged(environment);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.isEnabled) {
	                this.enable();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var willBeEnabled = _ref.isEnabled;
	            var isEnabled = this.props.isEnabled;
	
	            var isEnabledWillChange = isEnabled !== willBeEnabled;
	
	            if (!isEnabledWillChange) {
	                return;
	            }
	
	            if (willBeEnabled) {
	                this.enable();
	            } else {
	                this.disable();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearTimers();
	            this.disable();
	        }
	    }, {
	        key: 'enable',
	        value: function enable() {
	            this.addEventListeners();
	        }
	    }, {
	        key: 'disable',
	        value: function disable() {
	            this.removeEventListeners();
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            this.core = new _ElementRelativeCursorPosition2.default(this.el);
	
	            this.setElementDimensionsState(this.getElementDimensions(this.el));
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            var _core = this.core;
	            _core = _core === undefined ? {} : _core;
	            var lastMouseEvent = _core.lastEvent;
	
	
	            this.init();
	
	            if (!lastMouseEvent) {
	                return;
	            }
	
	            this.setPositionState(this.core.getCursorPosition(lastMouseEvent));
	        }
	    }, {
	        key: 'activate',
	        value: function activate() {
	            this.setState({ isActive: true });
	            this.props.onActivationChanged({ isActive: true });
	        }
	    }, {
	        key: 'deactivate',
	        value: function deactivate() {
	            var _this2 = this;
	
	            this.clearTimer(constants.PRESS_EVENT_TIMER_NAME);
	
	            this.setState({ isActive: false }, function () {
	                var _state = _this2.state,
	                    isPositionOutside = _state.isPositionOutside,
	                    position = _state.position;
	
	
	                _this2.props.onPositionChanged({
	                    isPositionOutside: isPositionOutside,
	                    position: position
	                });
	
	                _this2.props.onActivationChanged({ isActive: false });
	            });
	        }
	    }, {
	        key: 'setPositionState',
	        value: function setPositionState(position) {
	            var isPositionOutside = this.getIsPositionOutside(position);
	
	            this.setState({
	                isPositionOutside: isPositionOutside,
	                position: position
	            }, this.onPositionChanged);
	        }
	    }, {
	        key: 'setElementDimensionsState',
	        value: function setElementDimensionsState(dimensions) {
	            this.setState({
	                elementDimensions: dimensions
	            });
	        }
	    }, {
	        key: 'schedulActivation',
	        value: function schedulActivation(schedule) {
	            var _this3 = this;
	
	            var scheduleId = setTimeout(function () {
	                _this3.activate();
	            }, schedule);
	
	            this.timers.push({
	                id: scheduleId,
	                name: constants.SET_ACTIVATION_TIMER_NAME
	            });
	        }
	    }, {
	        key: 'scheduleDeactivation',
	        value: function scheduleDeactivation(schedule) {
	            var _this4 = this;
	
	            var scheduleId = setTimeout(function () {
	                _this4.deactivate();
	            }, schedule);
	
	            this.timers.push({
	                id: scheduleId,
	                name: constants.UNSET_ACTIVATION_TIMER_NAME
	            });
	        }
	    }, {
	        key: 'clearActivationTimers',
	        value: function clearActivationTimers() {
	            this.clearTimer(constants.SET_ACTIVATION_TIMER_NAME);
	            this.clearTimer(constants.UNSET_ACTIVATION_TIMER_NAME);
	        }
	    }, {
	        key: 'setPressEventTimer',
	        value: function setPressEventTimer() {
	            var _this5 = this;
	
	            var _props = this.props,
	                pressDuration = _props.pressDuration,
	                pressMoveThreshold = _props.pressMoveThreshold;
	
	
	            this.timers.push({
	                name: constants.PRESS_EVENT_TIMER_NAME,
	                id: setTimeout(function () {
	                    if (Math.abs(_this5.currentElTop - _this5.initialElTop) < pressMoveThreshold) {
	                        _this5.activate();
	                    }
	                }, pressDuration)
	            });
	        }
	    }, {
	        key: 'setPressEventCriteria',
	        value: function setPressEventCriteria(position) {
	            this.currentElTop = position.y;
	        }
	    }, {
	        key: 'initPressEventCriteria',
	        value: function initPressEventCriteria(position) {
	            var top = position.y;
	            this.initialElTop = top;
	            this.currentElTop = top;
	        }
	    }, {
	        key: 'setShouldGuardAgainstMouseEmulationByDevices',
	        value: function setShouldGuardAgainstMouseEmulationByDevices() {
	            this.shouldGuardAgainstMouseEmulationByDevices = true;
	        }
	    }, {
	        key: 'unsetShouldGuardAgainstMouseEmulationByDevices',
	        value: function unsetShouldGuardAgainstMouseEmulationByDevices() {
	            var _this6 = this;
	
	            this.timers.push({
	                name: constants.MOUSE_EMULATION_GUARD_TIMER_NAME,
	                id: setTimeout(function () {
	                    _this6.shouldGuardAgainstMouseEmulationByDevices = false;
	                }, 0)
	            });
	        }
	    }, {
	        key: 'clearTimers',
	        value: function clearTimers() {
	            var timers = this.timers;
	            while (timers.length) {
	                var timer = timers.pop();
	                clearTimeout(timer.id);
	            }
	        }
	    }, {
	        key: 'clearTimer',
	        value: function clearTimer(timerName) {
	            this.timers.forEach(function (timer) {
	                if (timer.name === timerName) {
	                    clearTimeout(timer.id);
	                }
	            });
	        }
	    }, {
	        key: 'getElementDimensions',
	        value: function getElementDimensions(el) {
	            var _el$getBoundingClient = el.getBoundingClientRect(),
	                width = _el$getBoundingClient.width,
	                height = _el$getBoundingClient.height;
	
	            return {
	                width: width,
	                height: height
	            };
	        }
	    }, {
	        key: 'getIsPositionOutside',
	        value: function getIsPositionOutside(position) {
	            var x = position.x,
	                y = position.y;
	            var _state$elementDimensi = this.state.elementDimensions,
	                width = _state$elementDimensi.width,
	                height = _state$elementDimensi.height;
	
	
	            var isPositionOutside = x < 0 || y < 0 || x > width || y > height;
	
	            return isPositionOutside;
	        }
	    }, {
	        key: 'getTouchEvent',
	        value: function getTouchEvent(e) {
	            return e.touches[0];
	        }
	    }, {
	        key: 'isReactComponent',
	        value: function isReactComponent(reactElement) {
	            return typeof reactElement.type === 'function';
	        }
	    }, {
	        key: 'shouldDecorateChild',
	        value: function shouldDecorateChild(child) {
	            return !!child && this.isReactComponent(child) && this.props.shouldDecorateChildren;
	        }
	    }, {
	        key: 'decorateChild',
	        value: function decorateChild(child, props) {
	            return (0, _react.cloneElement)(child, props);
	        }
	    }, {
	        key: 'decorateChildren',
	        value: function decorateChildren(children, props) {
	            var _this7 = this;
	
	            return _react.Children.map(children, function (child) {
	                return _this7.shouldDecorateChild(child) ? _this7.decorateChild(child, props) : child;
	            });
	        }
	    }, {
	        key: 'addEventListeners',
	        value: function addEventListeners() {
	            this.eventListeners.push((0, _addEventListener2.default)(this.el, 'touchstart', this.onTouchStart, { passive: false }), (0, _addEventListener2.default)(this.el, 'touchmove', this.onTouchMove, { passive: false }), (0, _addEventListener2.default)(this.el, 'touchend', this.onTouchEnd), (0, _addEventListener2.default)(this.el, 'touchcancel', this.onTouchCancel), (0, _addEventListener2.default)(this.el, 'mouseenter', this.onMouseEnter), (0, _addEventListener2.default)(this.el, 'mousemove', this.onMouseMove), (0, _addEventListener2.default)(this.el, 'mouseleave', this.onMouseLeave));
	        }
	    }, {
	        key: 'removeEventListeners',
	        value: function removeEventListeners() {
	            while (this.eventListeners.length) {
	                this.eventListeners.pop().removeEventListener();
	            }
	        }
	    }, {
	        key: 'getPassThroughProps',
	        value: function getPassThroughProps() {
	            var ownPropNames = Object.keys(this.constructor.propTypes);
	            return (0, _object2.default)(this.props, ownPropNames);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var _props2 = this.props,
	                children = _props2.children,
	                className = _props2.className,
	                mapChildProps = _props2.mapChildProps,
	                style = _props2.style;
	
	            var props = (0, _objectAssign2.default)({}, mapChildProps(this.state), this.getPassThroughProps());
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: className,
	                    ref: function ref(el) {
	                        return _this8.el = el;
	                    },
	                    style: (0, _objectAssign2.default)({}, style, {
	                        WebkitUserSelect: 'none'
	                    })
	                },
	                this.decorateChildren(children, props)
	            );
	        }
	    }]);
	
	    return _class;
	}(_react2.default.Component);
	
	_class.displayName = 'ReactCursorPosition';
	_class.propTypes = {
	    children: _propTypes2.default.any,
	    className: _propTypes2.default.string,
	    hoverDelayInMs: _propTypes2.default.number,
	    hoverOffDelayInMs: _propTypes2.default.number,
	    isActivatedOnTouch: _propTypes2.default.bool,
	    isEnabled: _propTypes2.default.bool,
	    mapChildProps: _propTypes2.default.func,
	    onActivationChanged: _propTypes2.default.func,
	    onPositionChanged: _propTypes2.default.func,
	    onDetectedEnvironmentChanged: _propTypes2.default.func,
	    pressDuration: _propTypes2.default.number,
	    pressMoveThreshold: _propTypes2.default.number,
	    shouldDecorateChildren: _propTypes2.default.bool,
	    shouldStopTouchMovePropagation: _propTypes2.default.bool,
	    style: _propTypes2.default.object
	};
	_class.defaultProps = {
	    isActivatedOnTouch: false,
	    isEnabled: true,
	    hoverDelayInMs: 0,
	    hoverOffDelayInMs: 0,
	    mapChildProps: function mapChildProps(props) {
	        return props;
	    },
	    onActivationChanged: _noop2.default,
	    onPositionChanged: _noop2.default,
	    onDetectedEnvironmentChanged: _noop2.default,
	    pressDuration: 500,
	    pressMoveThreshold: 5,
	    shouldDecorateChildren: true,
	    shouldStopTouchMovePropagation: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this9 = this;
	
	    this.onPositionChanged = function () {
	        var onPositionChanged = _this9.props.onPositionChanged;
	
	        onPositionChanged(_this9.state);
	    };
	};
	
	exports.default = _class;

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PRESS_EVENT_TIMER_NAME = exports.PRESS_EVENT_TIMER_NAME = 'pressEvent';
	var MOUSE_EMULATION_GUARD_TIMER_NAME = exports.MOUSE_EMULATION_GUARD_TIMER_NAME = 'mouseEmulation';
	var SET_ACTIVATION_TIMER_NAME = exports.SET_ACTIVATION_TIMER_NAME = 'setHovering';
	var UNSET_ACTIVATION_TIMER_NAME = exports.UNSET_ACTIVATION_TIMER_NAME = 'unsetHovering';

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ElementRelativeCursorPosition = function () {
	    function ElementRelativeCursorPosition(el) {
	        _classCallCheck(this, ElementRelativeCursorPosition);
	
	        this.el = el;
	    }
	
	    _createClass(ElementRelativeCursorPosition, [{
	        key: "getDocumentRelativeElementOffset",
	        value: function getDocumentRelativeElementOffset(el) {
	            var rootEl = this.getRootOfEl(el);
	
	            var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
	                docLeft = _rootEl$getBoundingCl.left,
	                docTop = _rootEl$getBoundingCl.top;
	
	            var _el$getBoundingClient = el.getBoundingClientRect(),
	                elLeft = _el$getBoundingClient.left,
	                elTop = _el$getBoundingClient.top;
	
	            return {
	                x: Math.abs(docLeft) + elLeft,
	                y: Math.abs(docTop) + elTop
	            };
	        }
	    }, {
	        key: "getRootOfEl",
	        value: function getRootOfEl(el) {
	            if (el.parentElement) {
	                return this.getRootOfEl(el.parentElement);
	            }
	            return el;
	        }
	    }, {
	        key: "getComputedElementRelativeCursorPosition",
	        value: function getComputedElementRelativeCursorPosition(event, documentRelativeElementOffset) {
	            this.lastEvent = event;
	            var position = this.getDocumentRelativeCursorPosition(event);
	            var cursorX = position.x,
	                cursorY = position.y;
	            var offsetX = documentRelativeElementOffset.x,
	                offsetY = documentRelativeElementOffset.y;
	
	
	            return {
	                x: Math.round(cursorX - offsetX),
	                y: Math.round(cursorY - offsetY)
	            };
	        }
	    }, {
	        key: "getDocumentRelativeCursorPosition",
	        value: function getDocumentRelativeCursorPosition(event) {
	            return {
	                x: event.pageX,
	                y: event.pageY
	            };
	        }
	    }, {
	        key: "getCursorPosition",
	        value: function getCursorPosition(event) {
	            return this.getComputedElementRelativeCursorPosition(event, this.documentRelativeElementOffset);
	        }
	    }, {
	        key: "documentRelativeElementOffset",
	        get: function get() {
	            if (!this.elementOffset) {
	                this.elementOffset = this.getDocumentRelativeElementOffset(this.el);
	            }
	
	            return this.elementOffset;
	        }
	    }]);
	
	    return ElementRelativeCursorPosition;
	}();
	
	exports.default = ElementRelativeCursorPosition;

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = addEventListener;
	function addEventListener(node, eventName, handler, options) {
	    node.addEventListener(eventName, handler, options);
	    return {
	        removeEventListener: function removeEventListener() {
	            node.removeEventListener(eventName, handler, options);
	        }
	    };
	}

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {};

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 3);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UAParser = __webpack_require__(6);
	
	var UA = exports.UA = new UAParser();
	
	var browser = exports.browser = UA.getBrowser();
	var cpu = exports.cpu = UA.getCPU();
	var device = exports.device = UA.getDevice();
	var engine = exports.engine = UA.getEngine();
	var os = exports.os = UA.getOS();
	var ua = exports.ua = UA.getUA();
	var setUA = exports.setUA = function setUA(uaStr) {
	  return UA.setUA(uaStr);
	};
	
	var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
	  window.navigator.__defineGetter__("userAgent", function () {
	    return userAgent;
	  });
	};
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isYandex = exports.isEdge = exports.getUA = exports.engineVersion = exports.engineName = exports.mobileModel = exports.mobileVendor = exports.browserName = exports.browserVersion = exports.fullBrowserVersion = exports.osName = exports.osVersion = exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = exports.isChromium = exports.isMobileSafari = exports.isWearable = exports.isConsole = exports.isSmartTV = undefined;
	
	var _getUaData = __webpack_require__(0);
	
	var _types = __webpack_require__(2);
	
	var CHROME = _types.BROWSER_TYPES.CHROME,
	    CHROMIUM = _types.BROWSER_TYPES.CHROMIUM,
	    IE = _types.BROWSER_TYPES.IE,
	    INTERNET_EXPLORER = _types.BROWSER_TYPES.INTERNET_EXPLORER,
	    OPERA = _types.BROWSER_TYPES.OPERA,
	    FIREFOX = _types.BROWSER_TYPES.FIREFOX,
	    SAFARI = _types.BROWSER_TYPES.SAFARI,
	    MOBILE_SAFARI = _types.BROWSER_TYPES.MOBILE_SAFARI,
	    EDGE = _types.BROWSER_TYPES.EDGE,
	    YANDEX = _types.BROWSER_TYPES.YANDEX;
	var MOBILE = _types.DEVICE_TYPES.MOBILE,
	    TABLET = _types.DEVICE_TYPES.TABLET,
	    SMART_TV = _types.DEVICE_TYPES.SMART_TV,
	    BROWSER = _types.DEVICE_TYPES.BROWSER,
	    WEARABLE = _types.DEVICE_TYPES.WEARABLE,
	    CONSOLE = _types.DEVICE_TYPES.CONSOLE;
	var ANDROID = _types.OS_TYPES.ANDROID,
	    WINDOWS_PHONE = _types.OS_TYPES.WINDOWS_PHONE,
	    IOS = _types.OS_TYPES.IOS;
	
	
	var isMobileType = function isMobileType() {
	  return _getUaData.device.type === MOBILE;
	};
	var isTabletType = function isTabletType() {
	  return _getUaData.device.type === TABLET;
	};
	
	var isMobileAndTabletType = function isMobileAndTabletType() {
	  switch (_getUaData.device.type) {
	    case MOBILE:
	    case TABLET:
	      return true;
	    default:
	      return false;
	  }
	};
	
	var isSmartTVType = function isSmartTVType() {
	  return _getUaData.device.type === SMART_TV;
	};
	var isBrowserType = function isBrowserType() {
	  return _getUaData.device.type === BROWSER;
	};
	var isWearableType = function isWearableType() {
	  return _getUaData.device.type === WEARABLE;
	};
	var isConsoleType = function isConsoleType() {
	  return _getUaData.device.type === CONSOLE;
	};
	var isAndroidType = function isAndroidType() {
	  return _getUaData.os.name === ANDROID;
	};
	var isWinPhoneType = function isWinPhoneType() {
	  return _getUaData.os.name === WINDOWS_PHONE;
	};
	var isIOSType = function isIOSType() {
	  return _getUaData.os.name === IOS;
	};
	var isChromeType = function isChromeType() {
	  return _getUaData.browser.name === CHROME;
	};
	var isFirefoxType = function isFirefoxType() {
	  return _getUaData.browser.name === FIREFOX;
	};
	var isChromiumType = function isChromiumType() {
	  return _getUaData.browser.name === CHROMIUM;
	};
	var isEdgeType = function isEdgeType() {
	  return _getUaData.browser.name === EDGE;
	};
	var isYandexType = function isYandexType() {
	  return _getUaData.browser.name === YANDEX;
	};
	var isSafariType = function isSafariType() {
	  return _getUaData.browser.name === SAFARI || _getUaData.browser.name === MOBILE_SAFARI;
	};
	var isMobileSafariType = function isMobileSafariType() {
	  return _getUaData.browser.name === MOBILE_SAFARI;
	};
	var isOperaType = function isOperaType() {
	  return _getUaData.browser.name === OPERA;
	};
	var isIEType = function isIEType() {
	  return _getUaData.browser.name === INTERNET_EXPLORER || _getUaData.browser.name === IE;
	};
	
	var getBrowserFullVersion = function getBrowserFullVersion() {
	  return _getUaData.browser.major;
	};
	var getBrowserVersion = function getBrowserVersion() {
	  return _getUaData.browser.version;
	};
	var getOsVersion = function getOsVersion() {
	  return _getUaData.os.version ? _getUaData.os.version : "none";
	};
	var getOsName = function getOsName() {
	  return _getUaData.os.name ? _getUaData.os.name : "none";
	};
	var getBrowserName = function getBrowserName() {
	  return _getUaData.browser.name;
	};
	var getMobileVendor = function getMobileVendor() {
	  return _getUaData.device.vendor ? _getUaData.device.vendor : "none";
	};
	var getMobileModel = function getMobileModel() {
	  return _getUaData.device.model ? _getUaData.device.model : "none";
	};
	var getEngineName = function getEngineName() {
	  return _getUaData.engine.name;
	};
	var getEngineVersion = function getEngineVersion() {
	  return _getUaData.engine.version;
	};
	var getUseragent = function getUseragent() {
	  return _getUaData.ua;
	};
	
	var isSmartTV = exports.isSmartTV = isSmartTVType();
	var isConsole = exports.isConsole = isConsoleType();
	var isWearable = exports.isWearable = isWearableType();
	var isMobileSafari = exports.isMobileSafari = isMobileSafariType();
	var isChromium = exports.isChromium = isChromiumType();
	var isMobile = exports.isMobile = isMobileAndTabletType();
	var isMobileOnly = exports.isMobileOnly = isMobileType();
	var isTablet = exports.isTablet = isTabletType();
	var isBrowser = exports.isBrowser = isBrowserType();
	var isAndroid = exports.isAndroid = isAndroidType();
	var isWinPhone = exports.isWinPhone = isWinPhoneType();
	var isIOS = exports.isIOS = isIOSType();
	var isChrome = exports.isChrome = isChromeType();
	var isFirefox = exports.isFirefox = isFirefoxType();
	var isSafari = exports.isSafari = isSafariType();
	var isOpera = exports.isOpera = isOperaType();
	var isIE = exports.isIE = isIEType();
	var osVersion = exports.osVersion = getOsVersion();
	var osName = exports.osName = getOsName();
	var fullBrowserVersion = exports.fullBrowserVersion = getBrowserFullVersion();
	var browserVersion = exports.browserVersion = getBrowserVersion();
	var browserName = exports.browserName = getBrowserName();
	var mobileVendor = exports.mobileVendor = getMobileVendor();
	var mobileModel = exports.mobileModel = getMobileModel();
	var engineName = exports.engineName = getEngineName();
	var engineVersion = exports.engineVersion = getEngineVersion();
	var getUA = exports.getUA = getUseragent();
	var isEdge = exports.isEdge = isEdgeType();
	var isYandex = exports.isYandex = isYandexType();
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wearPayload = exports.consolePayload = exports.stvPayload = exports.mobilePayload = exports.broPayload = exports.getCurrentBrowser = exports.checkType = exports.OS_TYPES = exports.BROWSER_TYPES = exports.DEVICE_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _getUaData = __webpack_require__(0);
	
	var DEVICE_TYPES = exports.DEVICE_TYPES = {
	  MOBILE: 'mobile',
	  TABLET: 'tablet',
	  SMART_TV: 'smarttv',
	  CONSOLE: 'console',
	  WEARABLE: 'wearable',
	  BROWSER: undefined
	};
	
	var BROWSER_TYPES = exports.BROWSER_TYPES = {
	  CHROME: 'Chrome',
	  FIREFOX: "Firefox",
	  OPERA: "Opera",
	  YANDEX: "Yandex",
	  SAFARI: "Safari",
	  INTERNET_EXPLORER: "Internet Explorer",
	  EDGE: "Edge",
	  CHROMIUM: "Chromium",
	  IE: 'IE',
	  MOBILE_SAFARI: "Mobile Safari"
	};
	
	var OS_TYPES = exports.OS_TYPES = {
	  IOS: 'iOS',
	  ANDROID: "Android",
	  WINDOWS_PHONE: "Windows Phone"
	};
	
	var initialData = {
	  isMobile: false,
	  isTablet: false,
	  isBrowser: false,
	  isSmartTV: false,
	  isConsole: false,
	  isWearable: false
	};
	
	var checkType = exports.checkType = function checkType(type) {
	  switch (type) {
	    case DEVICE_TYPES.MOBILE:
	      return { isMobile: true };
	    case DEVICE_TYPES.TABLET:
	      return { isTablet: true };
	    case DEVICE_TYPES.SMART_TV:
	      return { isSmartTV: true };
	    case DEVICE_TYPES.CONSOLE:
	      return { isConsole: true };
	    case DEVICE_TYPES.WEARABLE:
	      return { isWearable: true };
	    case DEVICE_TYPES.BROWSER:
	      return { isBrowser: true };
	    default:
	      return initialData;
	  }
	};
	
	var getCurrentBrowser = exports.getCurrentBrowser = function getCurrentBrowser(name) {
	  switch (name) {
	    case BROWSER_TYPES.CHROME:
	    case BROWSER_TYPES.FIREFOX:
	    case BROWSER_TYPES.OPERA:
	    case BROWSER_TYPES.YANDEX:
	    case BROWSER_TYPES.SAFARI:
	    case BROWSER_TYPES.IE:
	    case BROWSER_TYPES.EDGE:
	    case BROWSER_TYPES.CHROMIUM:
	      return true;
	    default:
	      return false;
	  }
	};
	
	var broPayload = exports.broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
	  return {
	    isBrowser: isBrowser,
	    browserMajorVersion: browser.major,
	    browserFullVersion: browser.version,
	    browserName: browser.name,
	    engineName: engine.name || false,
	    engineVersion: engine.version,
	    osName: os.name,
	    osVersion: os.version,
	    userAgent: ua
	  };
	};
	
	var mobilePayload = exports.mobilePayload = function mobilePayload(type, device, os, ua) {
	  return _extends({}, type, {
	    vendor: device.vendor || "none",
	    model: device.model || "none",
	    os: os.name || "none",
	    osVersion: os.version || "none",
	    ua: ua || "none"
	  });
	};
	
	var stvPayload = exports.stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
	  return {
	    isSmartTV: isSmartTV,
	    engineName: engine.name || false,
	    engineVersion: engine.version,
	    osName: os.name,
	    osVersion: os.version,
	    userAgent: ua
	  };
	};
	
	var consolePayload = exports.consolePayload = function consolePayload(isConsole, engine, os, ua) {
	  return {
	    isConsole: isConsole,
	    engineName: engine.name || false,
	    engineVersion: engine.version,
	    osName: os.name,
	    osVersion: os.version,
	    userAgent: ua
	  };
	};
	
	var wearPayload = exports.wearPayload = function wearPayload(isWearable, engine, os, ua) {
	  return {
	    isWearable: isWearable,
	    engineName: engine.name || false,
	    engineVersion: engine.version,
	    osName: os.name,
	    osVersion: os.version,
	    userAgent: ua
	  };
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deviceDetect = undefined;
	
	var _views = __webpack_require__(4);
	
	Object.keys(_views).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _views[key];
	    }
	  });
	});
	
	var _selectors = __webpack_require__(1);
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});
	
	var _detect = __webpack_require__(8);
	
	var _detect2 = _interopRequireDefault(_detect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.deviceDetect = _detect2.default;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomView = exports.WearableView = exports.ConsoleView = exports.SmartTVView = exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectors = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AndroidView = exports.AndroidView = function AndroidView(props) {
	  return _selectors.isAndroid ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var BrowserView = exports.BrowserView = function BrowserView(props) {
	  return _selectors.isBrowser ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var IEView = exports.IEView = function IEView(props) {
	  return _selectors.isIE ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var IOSView = exports.IOSView = function IOSView(props) {
	  return _selectors.isIOS ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var MobileView = exports.MobileView = function MobileView(props) {
	  return _selectors.isMobile ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var TabletView = exports.TabletView = function TabletView(props) {
	  return _selectors.isTablet ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var WinPhoneView = exports.WinPhoneView = function WinPhoneView(props) {
	  return _selectors.isWinPhone ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(props) {
	  return _selectors.isMobileOnly ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var SmartTVView = exports.SmartTVView = function SmartTVView(props) {
	  return _selectors.isSmartTV ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var ConsoleView = exports.ConsoleView = function ConsoleView(props) {
	  return _selectors.isConsole ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var WearableView = exports.WearableView = function WearableView(props) {
	  return _selectors.isWearable ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var CustomView = exports.CustomView = function CustomView(props) {
	  return props.condition ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * UAParser.js v0.7.18
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 or MIT
	 */
	(function(window,undefined){"use strict";var LIBVERSION="0.7.18",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(BIDUBrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(7)){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
	module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getUaData = __webpack_require__(0);
	
	var _types = __webpack_require__(2);
	
	var create = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var type = create.checkType(_getUaData.device.type);
	
	exports.default = function () {
	  var isBrowser = type.isBrowser,
	      isMobile = type.isMobile,
	      isTablet = type.isTablet,
	      isSmartTV = type.isSmartTV,
	      isConsole = type.isConsole,
	      isWearable = type.isWearable;
	
	  if (isBrowser) {
	    return create.broPayload(isBrowser, _getUaData.browser, _getUaData.engine, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isSmartTV) {
	    return create.stvPayload(isSmartTV, _getUaData.engine, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isConsole) {
	    return create.consolePayload(isConsole, _getUaData.engine, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isMobile) {
	    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isTablet) {
	    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isWearable) {
	    return create.wearPayload(isWearable, _getUaData.engine, _getUaData.os, _getUaData.ua);
	  }
	};
	
	/***/ })
	/******/ ]);

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AndrewWave = function AndrewWave(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ viewBox: "0 0 536.65 165.12" }, props),
	    _react2.default.createElement(
	      "g",
	      { style: { isolation: "isolate" } },
	      _react2.default.createElement(
	        "g",
	        {
	          "data-name": "group copy 4",
	          style: { mixBlendMode: "screen" },
	          fill: "none",
	          stroke: "#0f0",
	          strokeMiterlimit: 10
	        },
	        _react2.default.createElement("path", { d: "M458.1 74.11a79.73 79.73 0 0 1-8.5-36.22l-.55-.09c-7.37 10.31-15 20.48-16.2 32a181.66 181.66 0 0 0-27.53-.4c-16.12-19.66-2.18-37.38-6.85-61.46a196.08 196.08 0 0 1 25.82-1.66c1.86 14.68-2.25 26.41-2.7 38.17h1c8.05-11.68 18.11-22.87 22.63-36.81a154.42 154.42 0 0 1 24.76 5.31c2.52 15 2.32 27.3 4.82 40.58l1.06.37c5.73-10.39 11.88-20.6 15.47-32.75a177.32 177.32 0 0 1 25 14.41c-6.3 17.92-19.04 32.42-27.58 49.72a163.84 163.84 0 0 0-30.65-11.17zM383.65 17.83c4.49 5.1 3.09 13.66-3.08 25-.72 1.38-1.42 2.75-2.08 4.11a369.15 369.15 0 0 0-48.86 13.1c-2.69 5-3.15 8.22-1.86 9.9s4.37 1.7 8.9.26a25.72 25.72 0 0 0 9.79-5.3 22.8 22.8 0 0 0 5.5-7.64c8-2.21 16.16-4.18 24.47-5.78-3.21 7.59-7 13.87-12.65 19.37s-13.33 9.68-24.9 13.43c-11.94 3.87-23.09 5.14-30.07 2.39s-7.76-10.09 0-22.81a209.54 209.54 0 0 1 23.71-31.66c7.91-8.49 15.89-14.6 26.76-17.68 11.15-3.24 20.03-1.76 24.37 3.31zm-46.73 29.66c7.59-2.45 15.26-4.72 23-6.74 2-3.55 2.58-6.18 1.78-7.83s-2.9-2.07-6.16-1.15c-7.29 2.05-13.06 7.44-18.62 15.72zM316.54 29.63a5.6 5.6 0 0 1 2 .08c-.38 7.49-3.91 15.22-8.26 23q-3.66 1.38-7.3 2.79a37.09 37.09 0 0 0-12.79 8.5 68.6 68.6 0 0 0-11 14.58c-6.11 10.87-10.34 21.27-6.05 29.9-7.7 3.37-15.36 6.78-23 10.17-9.45-20.37 24.41-48.87 25.1-71.11q9.32-4 18.59-7.81a28.57 28.57 0 0 1-.94 10.09 69.93 69.93 0 0 1 8.81-12 28.84 28.84 0 0 1 10.15-7.12 14.14 14.14 0 0 1 4.69-1.07zM217.6 132.85a20.89 20.89 0 0 1-3.31-9c-4.85 9.51-8.71 15.89-17.42 19.29-8.17 3.27-16.42 2.38-20.85-2.74s-3.65-14.22 3.67-26.63a228.65 228.65 0 0 1 20.41-29.28c6.2-7.36 12.24-12.41 20.79-15.76 7.12-2.82 13.43-2.9 16.58.46 2.68-10.48-.27-19.52-16.34-26.36q11.49-5 23-10.39c47.9 20.58-20.48 63.45-7.91 92.32q-9.31 4.13-18.62 8.09zm-12.68-30.44c-1.45 2.45-2.9 4.91-4.27 7.38-5.29 9.5-3.18 13.09 3.29 10.6 3.36-1.27 6.27-3.67 9.14-7.19a93.92 93.92 0 0 0 8.29-12.35q1.33-2.32 2.72-4.65c2.81-4.7 4.27-8.17 4.18-10.39s-1.93-2.63-5.34-1.3c-6.68 2.62-12.29 8.39-18.01 17.9zM176.11 90.28c3.16 2.9 2.79 8.36-1.91 16.73-8.17 14.91-19.17 30.48-15.06 47.27-7.82 2.27-15.69 4.24-23.63 5.81-3.17-16.35 5.37-30.33 12.57-43.8 1.55-2.87 2-5 1.32-6.35s-2.43-1.75-5.17-1.22a21.09 21.09 0 0 0-9.07 4.28 22.81 22.81 0 0 0-6.49 7.64c-6.42 12.75-13.81 26-11.22 42.29a182 182 0 0 1-24.3 1.2c-3.22-27.79 17-45.86 16.7-66.81a215.12 215.12 0 0 0 22.54-1.9 30.69 30.69 0 0 1 .34 9.08 64.6 64.6 0 0 1 12.3-9.61 48 48 0 0 1 13.93-5.88c7.85-1.9 14.07-1.73 17.15 1.27zM79.4 99.13c7.41 4.21 10.28 9.38 7.92 16.36-2.61 7.9-6.18 15.79-8.52 24.55a5.51 5.51 0 0 0 .12 3.73 3 3 0 0 0 2.7 1.75c1.49.12 3 .23 4.48.31a56.69 56.69 0 0 0-1.07 16.7 8.44 8.44 0 0 1-1.82.89 20.19 20.19 0 0 1-4.25 1 22 22 0 0 1-6.52-.16 25.92 25.92 0 0 1-12.19-5.11 19.13 19.13 0 0 1-6.6-8.87 24.1 24.1 0 0 1-10.62 3.62c-3.86.35-8.43-.65-13.77-3.27-15.81-8.07-24-21.15-24.74-34.24-.4-7 1.18-11 5.14-12s10 .09 17.81 2.55 18.05 6 30.11 9q.36-1.5.69-3a6.28 6.28 0 0 0-2.12-6.29 22 22 0 0 0-8.12-4.45 28.59 28.59 0 0 0-8.39-1.71c-2.4 0-3.67.87-3.84 2.8v.48a180.18 180.18 0 0 1-30.65-16.6 11.28 11.28 0 0 1-.28-2c-.49-6.9 3.15-9.37 11-8.36s19.07 5.21 33.16 10.1c12.79 4.42 23 7.95 30.37 12.22zm-42 24.51c-3.91.07-5.93 1.3-6.15 3.94-.33 4.23 2.53 7.86 8.37 10.06a12.57 12.57 0 0 0 9.13.25 7.25 7.25 0 0 0 5-5.47c.38-1.85.79-3.66 1.21-5.46-7.71-2.02-13.65-3.4-17.54-3.32z" })
	      ),
	      _react2.default.createElement(
	        "g",
	        {
	          "data-name": "group copy",
	          style: { mixBlendMode: "screen" },
	          fill: "none",
	          stroke: "#0025fc",
	          strokeMiterlimit: 10
	        },
	        _react2.default.createElement("path", { d: "M485.69 127.84a111.19 111.19 0 0 1-15.66-37.68h-.55c-4.86 11.58-8.32 23.21-5.64 35.83q-12.5-.81-25-1c-22.2-22.91-21-42.57-23.95-64.86 8.81-.18 17.68-.21 26.61 0 .79 13.2.26 25.57 3.7 38.29h.94c3.96-12.54 11.2-24.74 16.89-37.59 8.37.47 16.81 1.13 25.34 2 1.75 13.31 3.36 26.12 7.23 39.41l1 .13c3.74-12.28 9.17-24.31 13.66-36.7 8.49 1.32 17.07 2.9 25.74 4.8-8.17 20.28-21.16 39.54-25.17 60.86a472.5 472.5 0 0 0-25.14-3.49zM399.42 67.59c4.91 5.45 5 13.83 3.2 25.08-.2 1.37-.36 2.74-.47 4.11-17 .57-33.59 1.66-50 3-.65 4.64.55 8.06 2.95 10.26s6.13 3.1 10.78 2.75c4.24-.32 7.14-1.39 8.86-3.24a10 10 0 0 0 2.53-7q12.24-.75 24.7-1.19c.05 7.76-1 14-5 18.81s-10.93 7.58-22.9 8.46c-12.39.95-24.84-1-34.24-6.08s-14.2-13.27-11.36-24.66c2.84-11.17 9.55-20 17.37-26.47a49 49 0 0 1 28.5-11c11.77-.8 20.32 1.74 25.08 7.17zm-44.54 20.69q11.88-1 23.93-1.71c.88-3.33.73-5.93-.6-7.78s-3.69-2.68-7.11-2.44c-7.61.55-13.14 4.61-16.22 11.93zM329.24 64.83a7.15 7.15 0 0 1 2 .62c-1.23 7.12-3.69 14.08-6 21l-7.7.78a20.11 20.11 0 0 0-12.05 5.05 23.26 23.26 0 0 0-6.63 12.18c-2.05 9.82-1.83 19.63 4.62 29.82q-12.65 1.53-25.27 3.11c-13.23-23.25 4.31-44.63 7.07-66.89q9.89-1.13 19.75-2.22a68.73 68.73 0 0 1-.73 9.94 31.41 31.41 0 0 1 9-9.5 24.29 24.29 0 0 1 11.12-4.11 15.2 15.2 0 0 1 4.82.22zM242.32 141.74a45.31 45.31 0 0 1-5.19-9.85c-3.45 8.24-8.08 13.16-17.58 14.15-9 1-17.73-1.69-23.34-7.69s-7.18-15.07-3.61-26.64 8.64-20.05 14.25-26.2a31.62 31.62 0 0 1 21.25-10.47c7.48-.72 13.67 1.19 17.34 5.78 2-10.23 1.34-20.49-6.39-31.14q12.68-1.4 25.36-2.89c21.24 31.77-18.49 60.11-1.55 92.47q-10.27 1.26-20.54 2.48zm-24.67-35.26c-.71 2.23-1.39 4.47-2 6.72-2.34 8.69 1.17 12.9 8.11 12.17a11.37 11.37 0 0 0 8.39-4.87 32.46 32.46 0 0 0 4.79-10.66q.59-2.09 1.23-4.17c1.32-4.2 1.64-7.51.74-10s-3.13-3.39-6.68-3.09c-6.92.7-11.74 5.25-14.58 13.9zM182.3 85.04c3.5 4 4.13 9.85 1.67 17.82-4.29 14.22-9.61 28.84-5.39 45.13q-12.6.9-25.22 1.42c-2.87-15.28 1.39-28.95 5.12-42.21.81-2.83.68-5-.36-6.69s-2.94-2.4-5.64-2.31a13.16 13.16 0 0 0-8.3 3.17 14.05 14.05 0 0 0-4.74 7.39c-3.36 12.92-7.18 26.25-5.09 41.16-8.41.11-16.83.06-25.25-.2-2.14-25.2 9.34-46 8.3-68 7.23.18 14.4.22 21.5.16a59.64 59.64 0 0 1 1.2 9.87 36.72 36.72 0 0 1 11.13-8.47 33.35 33.35 0 0 1 13.65-3.57c7.84-.38 13.93 1.38 17.42 5.33zM89.34 83.9c6.93 3.9 10.06 9.47 8.83 17-1.35 8.54-3.35 17.12-4.68 26.07a5.81 5.81 0 0 0 .5 3.72 3.17 3.17 0 0 0 2.85 1.6l4.52.2a91.14 91.14 0 0 0-.58 15.77 9.89 9.89 0 0 1-1.91.84 26.89 26.89 0 0 1-4.43 1 28.89 28.89 0 0 1-6.7.19 27.4 27.4 0 0 1-12.25-3.49 14.58 14.58 0 0 1-6.46-7.28 34 34 0 0 1-10.88 5.24 32 32 0 0 1-14 .28c-15.83-2.87-23.68-11.39-23.71-24.14 0-6.68 1.87-11.37 5.74-14.09s9.49-4 16.73-4.14 16.64.6 27.93 1.74c.14-1.09.27-2.17.4-3.26a6.6 6.6 0 0 0-2.34-6.21 14.27 14.27 0 0 0-7.51-2.91 18.59 18.59 0 0 0-7.53.38 4.2 4.2 0 0 0-3.41 4v.51c-9.07-1.35-18.28-3-27.64-5a10 10 0 0 1-.13-1.85c0-6.5 3.54-10.83 10.41-13.23s16.52-2.5 28.9-.84c11.23 1.46 20.41 3.99 27.35 7.9zm-36.85 32.8c-3.71 1.09-5.65 2.93-5.84 5.61-.3 4.31 2.51 7 8.31 7.76a13.86 13.86 0 0 0 9-1.68 8.37 8.37 0 0 0 4.52-6.34c.24-1.93.5-3.85.76-5.76-7.42-.75-13.05-.69-16.75.41z" })
	      ),
	      _react2.default.createElement(
	        "g",
	        {
	          "data-name": "group copy 2",
	          style: { mixBlendMode: "screen" },
	          fill: "none",
	          stroke: "red",
	          strokeMiterlimit: 10
	        },
	        _react2.default.createElement("path", { d: "M466.59 131.92c-3.06-13.14-9-25.31-15.06-37.12H451c-1.27 12.08-1.52 24.44-5.87 38.29q-12.32.53-24.6.7c-4.73-25-27.5-45.2-35.5-66.51q13.92.21 28.18.11c2.91 12.54 10.85 24.71 17.27 37.64h.89c.38-13 .2-25.3 4.78-38q13.51-.41 27.41-1.23c3.13 12.51 9.26 24.74 14.43 37.44l.92-.06c1.85-13.14 4.14-25.95 8.56-39.17q14-1.27 28.41-3.15c-10.46 23.48-17.11 45.25-24.61 69q-12.34 1.22-24.68 2.06zM370.91 73.68c7.12 5.6 12.77 13.82 16.67 25.27.45 1.4.89 2.8 1.31 4.22-16.22-.29-32.19-.82-48-1.5 1.51 4.75 3.24 8.5 5.63 11.1s5.69 4 10.17 4.21c4.05.15 7-.68 8.65-2.46s2.16-4.17 1.4-7.14q11.69.36 23.51.57c2.1 8.12-.43 14.85-7 19.77s-16.64 7.4-28.5 6.93c-12.61-.47-20.5-4.37-25.9-11s-8.85-15.91-13.19-27.32c-4.27-11.16-4.78-19.19.58-24.54 5.21-5.33 14.56-7.72 26.17-7.23 12.21.51 21.3 3.54 28.5 9.12zm-34.14 16.43q11.7.49 23.56.89a17.28 17.28 0 0 0-5.61-7.93 15.15 15.15 0 0 0-9-3.18c-7.69-.29-10.9 3.06-8.95 10.22zM296.39 62.8a10.91 10.91 0 0 1 2.26.93c.49 6.84 2.91 13.55 5.61 20.3l-7.63-.41c-4.92-.26-7.92.83-9 3.31s-.55 6.28 1.05 11.49c2.93 9.72 3.68 19.79-2.45 30.74q-12.6-.81-25.21-1.68c15.6-24.21-5.14-44.31-8.38-66.41l19.63 1.21a60.16 60.16 0 0 0 3.76 10 9.75 9.75 0 0 1 4.84-8.13 18 18 0 0 1 10.44-2.27 18.19 18.19 0 0 1 5.08.92zM225.09 125.11a30.68 30.68 0 0 0 3.3-10 39.56 39.56 0 0 1-28.14 10.17c-9.22-.51-12.95-4-14.69-10.27s-2.16-14.9-5-26-4.63-19.33-1.75-25c2.7-5.63 8.86-8.35 17.4-7.87 7.32.39 13.55 3.39 19.62 8.74-3.17-10.27-4.1-21 2.51-32.7q12.68.9 25.34 1.85c-22.27 33.89 24.72 59.47 2 92.38-6.87-.41-13.73-.87-20.59-1.3zm-21.06-38.03a63.89 63.89 0 0 1 1.74 6.47c1.68 8.31 4.08 12.77 11.3 13.15 3.61.2 6.54-1 8.3-3.43s2.26-5.76 1.19-9.85c-.36-1.35-.76-2.69-1.2-4a24.77 24.77 0 0 0-6.42-10.14 14.52 14.52 0 0 0-9.42-4.28c-6.9-.33-8.37 3.73-5.49 12.08zM154.1 60.73a44.67 44.67 0 0 1 12 18.47c4.76 13.94 7.25 27.51-5 42.57q-12.71-.46-25.45-.71c11.07-14 10.29-26.71 6.7-39.66a13.38 13.38 0 0 0-4.32-6.72 10.72 10.72 0 0 0-7-2.66c-3.08 0-5.26.9-6.6 2.84s-1.64 4.35-1 7.2c3 12.64 3.09 25.09-7.14 38.8q-12.77 0-25.57.27c15.38-23.46 5.16-43.53.2-66.42q10.22-.07 20.28 0c1.35 3.48 2.86 6.89 4.41 10.25a17.71 17.71 0 0 1 7.65-8.4 22.69 22.69 0 0 1 12.25-3 27.74 27.74 0 0 1 18.59 7.17zM65.26 58.91c7.14 3.26 11.77 8.77 13.41 16.29 1.75 8.53 2.92 16.94 2 25.56a5.35 5.35 0 0 0 .57 3.49 3.06 3.06 0 0 0 3 1.29l4.86-.14a50.84 50.84 0 0 1-6.07 14.88 23.32 23.32 0 0 1-2.53.94 51.72 51.72 0 0 1-5.3 1.38 43.18 43.18 0 0 1-7.15.91c-5 .24-8.56-.31-11.09-1.66a8 8 0 0 1-4.38-6 78.29 78.29 0 0 1-13.37 7.24 52.7 52.7 0 0 1-15 3.81C8.71 128.62.7 123.52.42 110.68c0-6.67 2.1-12.06 6.19-16s9.9-7 17.32-9 17-3.34 28.62-4c-.13-1.09-.26-2.17-.4-3.26a7.43 7.43 0 0 0-3.76-5.75 13.6 13.6 0 0 0-7.82-1.58 17 17 0 0 0-7.16 1.89 4.61 4.61 0 0 0-2.71 4.68v.51q-13.67 1.11-27.87 2.75a8.79 8.79 0 0 1-.16-1.8c-.05-6.49 3.32-12 9.62-16.45s15.13-7.1 26.66-7.81c10.48-.65 19.08.79 26.31 4.05zM35.59 97.13c-3.9 1.9-5.9 4.2-6.05 6.86-.24 4.29 2.68 6.12 9 5.57a21.1 21.1 0 0 0 10-3.46c3-2 4.61-4.29 4.75-6.91.1-1.89.13-3.79.1-5.67-7.94.48-13.91 1.76-17.8 3.61z" })
	      ),
	      _react2.default.createElement(
	        "g",
	        {
	          "data-name": "group copy 3",
	          style: { mixBlendMode: "screen" },
	          fill: "none",
	          stroke: "#fff200",
	          strokeMiterlimit: 10
	        },
	        _react2.default.createElement("path", { d: "M471.34 102.85c-7.68-10.89-17.93-20.72-25.35-31l-.59.09c-.83 11.53 3 22.47 4.75 35.18-7.92 1.28-15.65 2.22-23.25 2.9-16.56-22-50.45-41-46.94-61.46 9.87.32 19.95.31 30.22-.17-4.22 12.19 4.37 23.42 14.45 34.89l.93-.07c-3-12-2.4-23.38 9.44-37a269.68 269.68 0 0 0 29.67-5.44c-1.93 12.8 4.94 23.39 12.39 34l1.08-.29c.7-12.71 4.36-25.94 12.18-41.34a251.93 251.93 0 0 0 29.91-13c-9.92 27.28-20.33 52.14-23.2 75.25a272.03 272.03 0 0 1-25.69 7.46zM362.11 54.04c5.66 5.57 10.09 13.47 17.55 24.38q1.32 2 2.76 4c-15.6-.46-30.18-1.57-44.19-2.9a64.54 64.54 0 0 0 11.17 11.29 20.43 20.43 0 0 0 11.15 4.47c3.56.23 5.62-.55 6.05-2.25s-.46-4-2.7-6.94c7.08.43 14.32.76 21.79.92 5.68 7.67 7.23 14 4.12 18.79s-10.6 7.36-21.14 6.85c-11.2-.52-19.81-4.58-27.9-11.37s-16.74-16.39-26.87-28.35c-9.81-11.69-12.07-19.81-6.41-24.5 5.49-4.7 16.62-6 28.55-4.65 12.72 1.42 20.43 4.7 26.07 10.26zm-32.75 13.75a896.7 896.7 0 0 0 22 2.12 29 29 0 0 0-6.7-7.92 16.59 16.59 0 0 0-8.84-3.59c-7.48-.8-10.71 2.16-6.46 9.39zM289.58 38.07a9.14 9.14 0 0 1 2 1.09c-1.11 6.61 2 13.48 6.87 20.52l-6.75-.89c-4.33-.59-6.46.36-6.15 2.88s2.87 6.53 7.32 12c8.24 10.31 15.18 20.68 13.5 31.21q-11.57-1.56-23.46-3.35c8.28-22.46-31.54-46.12-35.08-68.89q9.06 1.34 18.38 2.76a31.15 31.15 0 0 0 4.11 10.3 7 7 0 0 1 4-7.78 17.61 17.61 0 0 1 10.52-1.3 16.85 16.85 0 0 1 4.74 1.45z" }),
	        _react2.default.createElement("path", { d: "M248.27 96.28a16.72 16.72 0 0 0 1.36-9.31c-5.23 6.39-16.9 8.52-26.28 7.16-9.55-1.35-13-4.88-14.95-10.8s-3.63-14.09-11-25.34-13.58-19.93-13.37-25.77c-.09-5.84 4.72-8.59 12.38-7.76 6.62.68 12.62 4.13 19.62 10.08-6.18-11-7.68-22.38 3.74-34q13.31 2 27 4.3c-43 31.48 36.82 64.56 21.62 94.52zm-31.45-39c1.71 2.25 3.3 4.49 4.71 6.71 5.28 8.5 8.53 13 15.28 13.89 3.32.46 5.57-.45 6.08-2.81s-.66-5.68-3.75-10c-1-1.42-2.1-2.84-3.21-4.26a66 66 0 0 0-10.84-10.93c-3.73-3-7-4.62-10-5-5.99-.6-5.06 3.63 1.73 12.4zM161.14 28.28a102.29 102.29 0 0 1 19 19.17c10.66 14.28 18.13 27.46 2.44 40.19-9-.85-18.13-1.51-27.35-1.89 15.76-12.36 12.27-24.13 4.14-36.92a23.22 23.22 0 0 0-6.56-6.68 14.23 14.23 0 0 0-7.56-2.69c-2.9-.07-4.57.87-5.13 2.75s-.05 4.2 1.46 6.93c6.62 12.19 8.28 23.51-7.35 36.27-9.35.1-18.76.56-28.18 1.46 25.4-23.46 7-41.12-5.23-63 6.57-.56 13-.91 19.27-1.12 2.51 3.4 5.23 6.71 8 10a11.22 11.22 0 0 1 3.86-8.49c2.5-2.18 5.87-3.29 10-3.22 6.8-.01 12.94 2.54 19.19 7.24z" }),
	        _react2.default.createElement("path", { d: "M76.33 30.43c8.16 2.12 14.57 6.9 18 13.81 3.72 7.85 6.12 15.64 4.69 23.91a4.46 4.46 0 0 0 .39 3.27c.52.81 1.54 1.13 3.12 1 1.78-.18 3.55-.35 5.32-.5-1.69 4.68-4.83 9.53-9.93 14.86q-.69.33-3.09 1.2c-1.59.59-3.7 1.25-6.29 2a75.89 75.89 0 0 1-8.09 2c-5.43 1-9 1.14-11.28.23s-3.17-2.68-3-5.25C60.93 90.7 55.41 94.23 50 97.47a117.31 117.31 0 0 1-16.42 8.18c-15.66 6.44-23.31 4.57-24.91-7.6-.48-6.43 1.59-12.63 6.23-18.25s11.28-10.89 19.82-15.14a135.34 135.34 0 0 1 32.39-10.85c-.26-1-.55-2-.85-3a6.9 6.9 0 0 0-5-4.7 16.83 16.83 0 0 0-8.94.17 22.87 22.87 0 0 0-7.84 3.54c-2.12 1.55-3 3.29-2.58 5.17 0 .16.07.31.1.47A253.37 253.37 0 0 0 9.18 68.18a5.9 5.9 0 0 1-.31-1.67c-.52-6.23 3.27-13.23 10.16-19.85s16.45-12 28.69-15.28c11.14-3 20.31-3.03 28.61-.95zM48.68 72.28c-4.45 2.87-6.73 5.73-6.95 8.38-.36 4.32 2.74 5.23 9.88 3A37.58 37.58 0 0 0 63.03 78c3.51-2.58 5.49-5.11 5.7-7.67a41.76 41.76 0 0 0 .09-5.47c-8.9 1.91-15.71 4.58-20.14 7.42z" })
	      )
	    )
	  );
	};
	
	exports.default = AndrewWave;
	module.exports = exports["default"];

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(9);
	
	__webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'block first l' },
	      _react2.default.createElement(
	        'div',
	        { className: 'picFrame p1' },
	        _react2.default.createElement('div', { className: 'pfImg' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'picFrame p2' },
	        _react2.default.createElement('div', { className: 'pfImg' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'picFrame p3' },
	        _react2.default.createElement('div', { className: 'pfImg' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'picFrame p4' },
	        _react2.default.createElement('div', { className: 'pfImg' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'picFrame p5' },
	        _react2.default.createElement('div', { className: 'pfImg' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'picFrame p6' },
	        _react2.default.createElement('div', { className: 'pfImg' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'block r' },
	      _react2.default.createElement('div', { className: 'line' }),
	      _react2.default.createElement('div', { className: 'line' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            '\u2014\u2014'
	          ),
	          ' about'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'list' },
	        _react2.default.createElement(
	          'li',
	          null,
	          '18 years old'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'from West Chester, PA'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'currently interested in learning web development/UX Design'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Enrolled at ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.scad.edu/' },
	            'scad'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(227);
	
	var _andrewWave = __webpack_require__(127);
	
	var _andrewWave2 = _interopRequireDefault(_andrewWave);
	
	var _reactCursorPosition = __webpack_require__(265);
	
	var _reactCursorPosition2 = _interopRequireDefault(_reactCursorPosition);
	
	var _reactDeviceDetect = __webpack_require__(270);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_React$Component) {
	  _inherits(Banner, _React$Component);
	
	  function Banner(props) {
	    _classCallCheck(this, Banner);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { width: 0, height: 0 };
	    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
	    return _this;
	  }
	
	  Banner.prototype.componentDidMount = function componentDidMount() {
	    this.updateWindowDimensions();
	    window.addEventListener('resize', this.updateWindowDimensions);
	  };
	
	  Banner.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.updateWindowDimensions);
	  };
	
	  Banner.prototype.updateWindowDimensions = function updateWindowDimensions() {
	    this.setState({ width: window.innerWidth, height: window.innerHeight });
	  };
	
	  Banner.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'banner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'frame' },
	          _react2.default.createElement(
	            _reactCursorPosition2.default,
	            null,
	            _react2.default.createElement(BannerText, { height: this.state.height, width: this.state.width })
	          )
	        )
	      )
	    );
	  };
	
	  return Banner;
	}(_react2.default.Component);
	
	var BannerText = function BannerText(props) {
	  var _props$detectedEnviro = props.detectedEnvironment;
	  _props$detectedEnviro = _props$detectedEnviro === undefined ? {} : _props$detectedEnviro;
	  var _props$detectedEnviro2 = _props$detectedEnviro.isMouseDetected,
	      isMouseDetected = _props$detectedEnviro2 === undefined ? false : _props$detectedEnviro2,
	      _props$detectedEnviro3 = _props$detectedEnviro.isTouchDetected,
	      isTouchDetected = _props$detectedEnviro3 === undefined ? false : _props$detectedEnviro3,
	      _props$elementDimensi = props.elementDimensions;
	  _props$elementDimensi = _props$elementDimensi === undefined ? {} : _props$elementDimensi;
	  var _props$elementDimensi2 = _props$elementDimensi.width,
	      width = _props$elementDimensi2 === undefined ? 0 : _props$elementDimensi2,
	      _props$elementDimensi3 = _props$elementDimensi.height,
	      height = _props$elementDimensi3 === undefined ? 0 : _props$elementDimensi3,
	      _props$isActive = props.isActive,
	      isActive = _props$isActive === undefined ? false : _props$isActive,
	      _props$isPositionOuts = props.isPositionOutside,
	      isPositionOutside = _props$isPositionOuts === undefined ? false : _props$isPositionOuts,
	      _props$position = props.position;
	  _props$position = _props$position === undefined ? {} : _props$position;
	  var _props$position$x = _props$position.x,
	      x = _props$position$x === undefined ? 50 : _props$position$x,
	      _props$position$y = _props$position.y,
	      y = _props$position$y === undefined ? 0 : _props$position$y;
	
	
	  var circleXPos;
	  var circleYPos;
	
	  if (width < 800 && width > 501) {
	    circleYPos = 200;
	    circleXPos = -40;
	  } else if (width < 500) {
	    circleYPos = 0;
	    circleXPos = -40;
	  } else {
	    circleYPos = 150;
	    circleXPos = 30;
	  }
	
	  var style = {
	    top: y + circleYPos,
	    left: x + circleXPos,
	    cursor: "none"
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'waveContainer' },
	    _reactDeviceDetect.isMobile || props.height > 500 && props.width < 600 ? [_react2.default.createElement(_andrewWave2.default, { className: 'andrewWave' }), _react2.default.createElement(_andrewWave2.default, { className: 'andrewWave' }), _react2.default.createElement(_andrewWave2.default, { className: 'andrewWave' }), _react2.default.createElement(_andrewWave2.default, { className: 'andrewWave' }), _react2.default.createElement(_andrewWave2.default, { className: 'andrewWave' })] : _react2.default.createElement(_andrewWave2.default, { className: 'andrewWave' }),
	    isActive || isTouchDetected && x > 100 && _reactDeviceDetect.isBrowser ? _react2.default.createElement(
	      'svg',
	      { className: 'circle', style: style, height: '200', width: '200' },
	      _react2.default.createElement('circle', { cx: '62.5', cy: '62.5', r: '50', fill: 'black' })
	    ) : null
	  );
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(9);
	
	__webpack_require__(228);
	
	var _globe = __webpack_require__(135);
	
	var _globe2 = _interopRequireDefault(_globe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var colorData = {
	  colors: [{
	    id: 0,
	    color: "#8134AF"
	  }, {
	    id: 1,
	    color: "#24292e"
	  }, {
	    id: 2,
	    color: "#1DB954"
	  }, {
	    id: 3,
	    color: "#FFFC00"
	  }, {
	    id: 4,
	    color: "#DD4B39"
	  }]
	};
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.mouseOverHandler = function (index) {
	      var color = colorData.colors[index];
	
	      _this.setState({ currentColor: color });
	    };
	
	    _this.clickedHandler = function () {
	      var num = _this.state.currentColor.id + 1;
	      if (num == 4) {
	        _this.setState({ currentColor: colorData.colors[0] });
	      } else {
	        var clickColor = colorData.colors[num];
	
	        _this.setState({ currentColor: clickColor });
	      }
	    };
	
	    _this.state = {
	      currentColor: {
	        id: 0,
	        color: "#8134AF"
	      }
	    };
	    return _this;
	  }
	
	  Contact.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row newRow' },
	      _react2.default.createElement(
	        'div',
	        { className: 'block l' },
	        _react2.default.createElement(
	          'div',
	          { className: 'globeDiv' },
	          _react2.default.createElement(_globe2.default, { color: this.state.currentColor.color, clicked: this.clickedHandler })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'block r' },
	        _react2.default.createElement('div', { className: 'line' }),
	        _react2.default.createElement('div', { className: 'line' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              '\u2014\u2014'
	            ),
	            ' find me'
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { 'class': 'list contact' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onMouseOver: function onMouseOver() {
	                  return _this2.mouseOverHandler(0);
	                }, onTouchStart: function onTouchStart() {
	                  return _this2.mouseOverHandler(0);
	                }, href: 'https://www.instagram.com/ndrewgood/' },
	              'Instagram'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onMouseOver: function onMouseOver() {
	                  return _this2.mouseOverHandler(1);
	                }, onTouchStart: function onTouchStart() {
	                  return _this2.mouseOverHandler(1);
	                }, href: 'https://github.com/andrewg8' },
	              'Github'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onMouseOver: function onMouseOver() {
	                  return _this2.mouseOverHandler(2);
	                }, onTouchStart: function onTouchStart() {
	                  return _this2.mouseOverHandler(2);
	                }, href: 'https://open.spotify.com/user/22zbmyiz6chqqhzc6enozraoq?si=6v4EpqxYS-euz_-s5dFevA' },
	              'Spotify'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onMouseOver: function onMouseOver() {
	                  return _this2.mouseOverHandler(3);
	                }, onTouchStart: function onTouchStart() {
	                  return _this2.mouseOverHandler(3);
	                }, href: '/' },
	              'Snapchat'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onMouseOver: function onMouseOver() {
	                  return _this2.mouseOverHandler(4);
	                }, onTouchStart: function onTouchStart() {
	                  return _this2.mouseOverHandler(4);
	                }, href: 'mailto:hey@ndrewgood.com' },
	              'Email'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(229);
	
	__webpack_require__(9);
	
	var _recordPlayer = __webpack_require__(136);
	
	var _recordPlayer2 = _interopRequireDefault(_recordPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var musicData = {
	  artCovers: [{
	    id: 0,
	    artReg: "https://image.ibb.co/k85PKe/BasReg.png",
	    artBlur: "https://image.ibb.co/dvDBze/BasBlur.png"
	  }, {
	    id: 1,
	    artReg: "https://image.ibb.co/bGXtCz/AmineReg.png",
	    artBlur: "https://image.ibb.co/bGmaQK/Amine_Blur.png"
	  }, {
	    id: 2,
	    artReg: "https://image.ibb.co/mdGaQK/MacReg.png",
	    artBlur: "https://image.ibb.co/b6QPKe/MacBlur.png"
	  }, {
	    id: 3,
	    artReg: "https://image.ibb.co/cBEJee/Choker_Reg.png",
	    artBlur: "https://image.ibb.co/ermWze/Choker_Blur.png"
	  }, {
	    id: 4,
	    artReg: "https://image.ibb.co/g55MXz/Ariana_Reg.png",
	    artBlur: "https://image.ibb.co/mTcDee/Ariana_Blur.png"
	  }, {
	    id: 5,
	    artReg: "https://image.ibb.co/fAF25K/Goldlink_Reg.png",
	    artBlur: "https://image.ibb.co/cpsh5K/Goldlink_Blur.png"
	  }, {
	    id: 6,
	    artReg: "https://image.ibb.co/fpQ25K/KeysReg.png",
	    artBlur: "https://image.ibb.co/i9GmXz/KeysBlur.png"
	  }]
	};
	
	var Music = function (_React$Component) {
	  _inherits(Music, _React$Component);
	
	  function Music(props) {
	    _classCallCheck(this, Music);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.mouseOverHandler = function (index) {
	
	      var art = musicData.artCovers[index];
	
	      _this.setState({ currentArt: art });
	    };
	
	    _this.clickedHandler = function () {
	      var num = _this.state.currentArt.id + 1;
	      if (num == 7) {
	        _this.setState({ currentArt: musicData.artCovers[0] });
	      } else {
	        var clickArt = musicData.artCovers[num];
	
	        _this.setState({ currentArt: clickArt });
	      }
	    };
	
	    _this.state = {
	      currentArt: {
	        id: 0,
	        artReg: "https://image.ibb.co/k85PKe/BasReg.png",
	        artBlur: "https://image.ibb.co/dvDBze/BasBlur.png"
	      }
	    };
	    return _this;
	  }
	
	  Music.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row newRow' },
	      _react2.default.createElement(
	        'div',
	        { className: 'block l' },
	        _react2.default.createElement(
	          'div',
	          { className: 'rpcContainer' },
	          _react2.default.createElement(_recordPlayer2.default, { artReg: this.state.currentArt.artReg, artBlur: this.state.currentArt.artBlur, clicked: this.clickedHandler })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'block r' },
	        _react2.default.createElement('div', { className: 'line' }),
	        _react2.default.createElement('div', { className: 'line' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement(
	            'h1',
	            { onClick: this.clickedHandler },
	            _react2.default.createElement(
	              'span',
	              null,
	              '\u2014\u2014'
	            ),
	            ' music'
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'list musicList' },
	          _react2.default.createElement(
	            'li',
	            { id: 'musicLi' },
	            'Heres a short list of some of my favorite songs recently:',
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onMouseOver: function onMouseOver() {
	                    return _this2.mouseOverHandler(0);
	                  }, onTouchStart: function onTouchStart() {
	                    return _this2.mouseOverHandler(0);
	                  }, href: 'https://open.spotify.com/track/0YAQnYt2oB8OdoaeqnHyTI?si=5G-GomybSFO7DpU18xK-uw' },
	                'Tribe - Bas'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onMouseOver: function onMouseOver() {
	                    return _this2.mouseOverHandler(1);
	                  }, onTouchStart: function onTouchStart() {
	                    return _this2.mouseOverHandler(1);
	                  }, href: 'https://open.spotify.com/track/5qHirGR7M9tdm6C17DlzSY?si=XW0i3hcoTEyA3zi_IHdUzQ' },
	                'REEL IT IN - Amine '
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onMouseOver: function onMouseOver() {
	                    return _this2.mouseOverHandler(2);
	                  }, onTouchStart: function onTouchStart() {
	                    return _this2.mouseOverHandler(2);
	                  }, href: 'https://open.spotify.com/track/2N4idqj9TT3HnH2OFT9j0v?si=Ch7GR2qcSfCNOAr5eUcEUw' },
	                'Still Beating - Mac Demarco'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onMouseOver: function onMouseOver() {
	                    return _this2.mouseOverHandler(3);
	                  }, onTouchStart: function onTouchStart() {
	                    return _this2.mouseOverHandler(3);
	                  }, href: 'https://open.spotify.com/track/4BNqWebyipWrMsupuTmKO9?si=tu6Vx8tWTG2B9YqpgfWU7A' },
	                'Drift - Choker'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onMouseOver: function onMouseOver() {
	                    return _this2.mouseOverHandler(4);
	                  }, onTouchStart: function onTouchStart() {
	                    return _this2.mouseOverHandler(4);
	                  }, href: 'https://open.spotify.com/track/7sPbp28sThpD4opAhQsMTx?si=wEmFPpaITtCKJCtXQ9mXlg' },
	                'everytime - Ariana Grande'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onMouseOver: function onMouseOver() {
	                    return _this2.mouseOverHandler(5);
	                  }, onTouchStart: function onTouchStart() {
	                    return _this2.mouseOverHandler(5);
	                  }, href: 'https://open.spotify.com/track/564oa00vY05d1uYnTEAAmE?si=u66_saBOROuAGDy9viSl8w' },
	                'Herside Story - Goldlink'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onMouseOver: function onMouseOver() {
	                    return _this2.mouseOverHandler(6);
	                  }, onTouchStart: function onTouchStart() {
	                    return _this2.mouseOverHandler(6);
	                  }, href: 'https://open.spotify.com/track/39AS0BbUEoAwrBUo6vGUBD?si=FXFeTBQHSDq08GkwidjB7g' },
	                'Blended Family - Alicia Keys'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Music;
	}(_react2.default.Component);
	
	exports.default = Music;
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _window = __webpack_require__(137);
	
	var _window2 = _interopRequireDefault(_window);
	
	__webpack_require__(9);
	
	__webpack_require__(230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var windowsData = {
	  windows: [{ id: "0",
	    window1: "https://preview.ibb.co/fSdGDd/oldweb2.png",
	    window2: "https://preview.ibb.co/mMoGDd/oldweb3.png",
	    window3: "https://image.ibb.co/h8i56y/oldweb1.png" }, { id: "1",
	    window1: "https://images.unsplash.com/photo-1532128687411-528a85f8af03?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=411175c808e8e030a03b302de27dd809&auto=format&fit=crop&w=500&q=60",
	    window2: "https://images.unsplash.com/24/11843368213_6c58b49694_b.jpg?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=b9c52526c12abcb67c1ed8a147256b1f&auto=format&fit=crop&w=500&q=60",
	    window3: "https://images.unsplash.com/photo-1455052642859-f8449866e500?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=d26ebcff2c2def7e05bf4f9106483d81&auto=format&fit=crop&w=500&q=60" }, { id: "2",
	    window1: "https://images.unsplash.com/photo-1532119663789-58252470755c?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=090a1f1074f3df462abb541d93c08315&auto=format&fit=crop&w=1349&q=80",
	    window2: "https://images.unsplash.com/photo-1495471547134-98698271c52a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=edeb1740f47925655069ae7f2d60e1d5&auto=format&fit=crop&w=500&q=60",
	    window3: "https://images.unsplash.com/photo-1484980859177-5ac1249fda6f?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=e543d307ae464c76cb0de88a278293d7&auto=format&fit=crop&w=500&q=60" }]
	};
	
	var int = 0;
	
	var Projects = function (_React$Component) {
	  _inherits(Projects, _React$Component);
	
	  function Projects(props) {
	    _classCallCheck(this, Projects);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.mouseOverHandler = function (index) {
	
	      var project = windowsData.windows[index];
	
	      _this.setState({ currentProject: project });
	    };
	
	    _this.state = {
	      currentProject: {
	        id: "0",
	        window1: "https://preview.ibb.co/fSdGDd/oldweb2.png",
	        window2: "https://preview.ibb.co/mMoGDd/oldweb3.png",
	        window3: "https://image.ibb.co/h8i56y/oldweb1.png"
	      }
	    };
	    return _this;
	  }
	
	  Projects.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row newRow' },
	      _react2.default.createElement(
	        'div',
	        { className: 'block l' },
	        _react2.default.createElement(
	          'div',
	          { className: 'windowDiv wd1' },
	          _react2.default.createElement(_window2.default, { picture: this.state.currentProject.window1 })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'windowDiv wd2' },
	          _react2.default.createElement(_window2.default, { picture: this.state.currentProject.window2 })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'windowDiv wd3' },
	          _react2.default.createElement(_window2.default, { picture: this.state.currentProject.window3 })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'block r' },
	        _react2.default.createElement('div', { className: 'line' }),
	        _react2.default.createElement('div', { className: 'line' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              '\u2014\u2014'
	            ),
	            ' projects'
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'list' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onMouseOver: function onMouseOver() {
	                  return _this2.mouseOverHandler(0);
	                }, onTouchStart: function onTouchStart() {
	                  return _this2.mouseOverHandler(0);
	                }, className: 'pLink', href: 'https://github.com/andrewg8/pwb2' },
	              'My old website'
	            ),
	            _react2.default.createElement(
	              'li',
	              { onMouseOver: function onMouseOver() {
	                  return _this2.mouseOverHandler(0);
	                }, onTouchStart: function onTouchStart() {
	                  return _this2.mouseOverHandler(0);
	                } },
	              'the first website I made. other projects coming soon...'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Projects;
	}(_react2.default.Component);
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _banner = __webpack_require__(129);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _about = __webpack_require__(128);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _projects = __webpack_require__(132);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _music = __webpack_require__(131);
	
	var _music2 = _interopRequireDefault(_music);
	
	var _contact = __webpack_require__(130);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	__webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_banner2.default, null),
	        _react2.default.createElement(_about2.default, null),
	        _react2.default.createElement(_projects2.default, null),
	        _react2.default.createElement(_music2.default, null),
	        _react2.default.createElement(_contact2.default, null),
	        _react2.default.createElement(
	            'div',
	            { className: 'row footer' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'c 2018 andrew goodridge ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://github.com/andrewg8/pwb3-gatsby/blob/master/README.md' },
	                    'about the site'
	                )
	            )
	        )
	    );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(231);
	
	__webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Globe = function Globe(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'globeContainer' },
	    _react2.default.createElement('div', { className: 'smCircle', style: { backgroundColor: props.color }, onClick: function onClick() {
	        return props.clicked();
	      } }),
	    _react2.default.createElement(
	      'svg',
	      { id: 'Layer_2', x: '0px', y: '0px', viewBox: '0 0 797 795' },
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', { d: 'M397.3,1.1c53.5,0,105.4,10.5,154.3,31.2c47.2,20,89.6,48.5,126,85c36.4,36.4,65,78.8,85,126 c20.7,48.9,31.2,100.8,31.2,154.3s-10.5,105.4-31.2,154.3c-20,47.2-48.5,89.6-85,126c-36.4,36.4-78.8,65-126,85 c-48.9,20.7-100.8,31.2-154.3,31.2S291.9,783.4,243,762.7c-47.2-20-89.6-48.5-126-85c-36.4-36.4-65-78.8-85-126 C11.4,502.9,0.9,451,0.9,397.5S11.4,292,32.1,243.2c20-47.2,48.5-89.6,85-126c36.4-36.4,78.8-65,126-85 C291.9,11.6,343.8,1.1,397.3,1.1 M397.3,0.1C177.9,0.1-0.1,178-0.1,397.5s177.9,397.4,397.4,397.4s397.4-177.9,397.4-397.4 S616.8,0.1,397.3,0.1L397.3,0.1z' })
	      ),
	      _react2.default.createElement('line', { className: 'st0g', x1: '794.5', y1: '397.5', x2: '0.5', y2: '397.5' }),
	      _react2.default.createElement('line', { className: 'st0g', x1: '397.5', y1: '0.5', x2: '397.5', y2: '794.5' }),
	      _react2.default.createElement('circle', { className: 'st1g', cx: '397', cy: '397', r: '108.5' }),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', { d: 'M397.3,1.1c42.9,0,84.4,10.5,123.6,31.1c37.8,20,71.8,48.5,101,84.9c29.2,36.4,52.1,78.8,68.1,126 c16.6,48.9,25,100.8,25,154.4s-8.4,105.5-25,154.4c-16,47.2-38.9,89.6-68.1,126c-29.2,36.4-63.2,65-101,84.9 c-39.1,20.6-80.7,31.1-123.6,31.1s-84.4-10.5-123.6-31.1c-37.8-20-71.8-48.5-101-84.9c-29.2-36.4-52.1-78.8-68.1-126 c-16.6-48.9-25-100.8-25-154.4s8.4-105.5,25-154.4c16-47.2,38.9-89.6,68.1-126c29.2-36.4,63.2-65,101-84.9 C312.9,11.5,354.5,1.1,397.3,1.1 M397.3,0.1C221.3,0.1,78.7,178,78.7,397.5s142.7,397.4,318.7,397.4S716,616.9,716,397.5 S573.3,0.1,397.3,0.1L397.3,0.1z' })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', { d: 'M397.3,1.1C487.6,1.1,561,178.9,561,397.5s-73.4,396.4-163.7,396.4S233.7,616,233.7,397.5S307.1,1.1,397.3,1.1 M397.3,0.1 c-90.9,0-164.7,177.9-164.7,397.4s73.7,397.4,164.7,397.4S562,616.9,562,397.5S488.3,0.1,397.3,0.1L397.3,0.1z' })
	      ),
	      _react2.default.createElement('path', { className: 'st0g', d: 'M713,156c-87.4,30.7-197,49-316,49c-118.8,0-228.2-18.2-315.5-48.8' }),
	      _react2.default.createElement('path', { className: 'st0g', d: 'M81.5,638c87.4-30.7,197-49,316-49c118.8,0,228.2,18.2,315.5,48.8' })
	    )
	  );
	};
	
	exports.default = Globe;
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(232);
	
	__webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecordPlayer = function RecordPlayer(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'rpContainer' },
	    _react2.default.createElement('div', { onClick: function onClick() {
	        return props.clicked();
	      }, className: 'rpCircle' }),
	    _react2.default.createElement('div', { className: 'smallImage', style: { backgroundImage: 'url(' + props.artReg + ')' } }),
	    _react2.default.createElement(
	      'svg',
	      { x: '0px', y: '0px',
	        viewBox: '0 0 1035 848', className: 'Layer_2 rpFront' },
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('circle', { className: 'st0', cx: '413.5', cy: '434.5', r: '180' }),
	        _react2.default.createElement('circle', { className: 'st0', cx: '413.5', cy: '434.5', r: '161' }),
	        _react2.default.createElement('line', { className: 'st0', x1: '44.1', y1: '619.4', x2: '30', y2: '619.4' })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('rect', { x: '961', y: '131', transform: 'matrix(0.5817 -0.8134 0.8134 0.5817 295.9976 848.6098)', className: 'st0', width: '24', height: '11' }),
	        _react2.default.createElement('path', { className: 'st0', d: 'M901.9,176.7c-22.9-16.4-31.7-43.3-19.7-60.2s24.5,7,29.7,8.3c1.9,0.5,17,15.8,16.5,21.6 C928,152.1,924.8,193,901.9,176.7z' }),
	        _react2.default.createElement('rect', { x: '897.6', y: '40.5', transform: 'matrix(0.5817 -0.8134 0.8134 0.5817 340.2931 817.6689)', className: 'st0', width: '135', height: '75' }),
	        _react2.default.createElement('rect', { x: '482.9', y: '376.2', transform: 'matrix(0.5817 -0.8134 0.8134 0.5817 4.4049 785.0078)', className: 'st0', width: '565', height: '24' }),
	        _react2.default.createElement('rect', { x: '577', y: '668.3', transform: 'matrix(0.8772 -0.4802 0.4802 0.8772 -256.0718 362.4518)', className: 'st0', width: '7', height: '27' }),
	        _react2.default.createElement('rect', { x: '903.4', y: '80.1', transform: 'matrix(0.5817 -0.8134 0.8134 0.5817 273.6667 802.3423)', className: 'st0', width: '27', height: '110' }),
	        _react2.default.createElement('rect', { x: '546.4', y: '605.1', transform: 'matrix(0.8772 -0.4802 0.4802 0.8772 -228.9809 364.9548)', className: 'st0', width: '105', height: '50' }),
	        _react2.default.createElement('circle', { className: 'st0', cx: '916.6', cy: '135.5', r: '8' }),
	        _react2.default.createElement('path', { className: 'st1', d: 'M936.8,56.5' }),
	        _react2.default.createElement('path', { className: 'st1', d: 'M922.8,76.1' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '925.6', y1: '78', x2: '939.5', y2: '58.5' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '928.3', y1: '80', x2: '942.3', y2: '60.5' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '931.1', y1: '82', x2: '945', y2: '62.4' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '933.8', y1: '83.9', x2: '947.8', y2: '64.4' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '936.6', y1: '85.9', x2: '950.5', y2: '66.4' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '939.3', y1: '87.9', x2: '953.3', y2: '68.3' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '942.1', y1: '89.8', x2: '956', y2: '70.3' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '944.8', y1: '91.8', x2: '958.8', y2: '72.3' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '947.6', y1: '93.8', x2: '961.5', y2: '74.2' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '950.3', y1: '95.7', x2: '964.3', y2: '76.2' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '953.1', y1: '97.7', x2: '967', y2: '78.2' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '955.8', y1: '99.7', x2: '969.8', y2: '80.1' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '958.6', y1: '101.6', x2: '972.5', y2: '82.1' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '961.3', y1: '103.6', x2: '975.3', y2: '84.1' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '964.1', y1: '105.6', x2: '978', y2: '86' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '966.8', y1: '107.5', x2: '980.8', y2: '88' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '969.6', y1: '109.5', x2: '983.5', y2: '90' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '972.3', y1: '111.5', x2: '986.3', y2: '91.9' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '975.1', y1: '113.4', x2: '989', y2: '93.9' }),
	        _react2.default.createElement('line', { className: 'st1', x1: '977.8', y1: '115.4', x2: '991.8', y2: '95.9' }),
	        _react2.default.createElement('path', { className: 'st1', d: 'M994.5,97.8' }),
	        _react2.default.createElement('path', { className: 'st1', d: 'M980.6,117.4' })
	      )
	    ),
	    _react2.default.createElement('div', { className: 'bigImage', style: { backgroundImage: 'url(' + props.artBlur + ')' } }),
	    _react2.default.createElement(
	      'svg',
	      { id: 'Layer_2', x: '0px', y: '0px', viewBox: '0 0 1035 848' },
	      _react2.default.createElement('rect', { x: '30.5', y: '27.5', className: 'st0', width: '976', height: '787' }),
	      _react2.default.createElement('circle', { className: 'st0', cx: '413.5', cy: '434.5', r: '413' }),
	      _react2.default.createElement('circle', { className: 'st0', cx: '177.5', cy: '65.5', r: '18' }),
	      _react2.default.createElement('polyline', { className: 'st0', points: '826.5,30 826.5,216.5 876.5,352.5 1004,352.5 ' }),
	      _react2.default.createElement('circle', { className: 'st0', cx: '892.5', cy: '328.5', r: '11' }),
	      _react2.default.createElement('circle', { className: 'st0', cx: '958.5', cy: '297.5', r: '35' }),
	      _react2.default.createElement('circle', { className: 'st0', cx: '986.5', cy: '172.5', r: '9' }),
	      _react2.default.createElement('line', { className: 'st0', x1: '44.1', y1: '619.4', x2: '30', y2: '619.4' }),
	      _react2.default.createElement('line', { className: 'st0', x1: '781', y1: '623.2', x2: '1006', y2: '623.2' }),
	      _react2.default.createElement('polygon', { className: 'st0', points: '780.5,748.5 765.5,823.5 771.5,825.5 793.5,750.5 ' }),
	      _react2.default.createElement('circle', { className: 'st0', cx: '788.5', cy: '740.5', r: '15' }),
	      _react2.default.createElement('polygon', { className: 'st0', points: '949.6,750 1015.2,789.3 1019.1,784.3 955.9,738.4 ' }),
	      _react2.default.createElement('circle', { className: 'st0', cx: '944.8', cy: '739.7', r: '15' }),
	      _react2.default.createElement('circle', { className: 'st0', cx: '926.5', cy: '676.5', r: '8' }),
	      _react2.default.createElement('rect', { x: '981.5', y: '630.5', className: 'st0', width: '12', height: '33' }),
	      _react2.default.createElement('line', { className: 'st1', x1: '993.5', y1: '646.5', x2: '981.5', y2: '646.5' })
	    )
	  );
	};
	
	exports.default = RecordPlayer;
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(233);
	
	__webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Window = function Window(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { className: 'windowImg', style: { backgroundImage: 'url(' + props.picture + ')' } }),
	    _react2.default.createElement(
	      'svg',
	      { id: 'Layer_1', x: '0px', y: '0px', viewBox: '0 0 423 341' },
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('rect', { x: '0.5', y: '0.5', className: 'st0', width: '422', height: '340' }),
	        _react2.default.createElement('path', { d: 'M422,1v339H1V1H422 M423,0H0v341h423V0L423,0z' })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('line', { className: 'st1', x1: '-0.5', y1: '32.5', x2: '422.5', y2: '32.5' })
	      ),
	      _react2.default.createElement('line', { className: 'st1', x1: '390.5', y1: '0.5', x2: '390.5', y2: '32.5' }),
	      _react2.default.createElement('line', { className: 'st1', x1: '358.5', y1: '1', x2: '358.5', y2: '33' }),
	      _react2.default.createElement('line', { className: 'st1', x1: '326.5', y1: '1', x2: '326.5', y2: '33' }),
	      _react2.default.createElement('line', { className: 'st1', x1: '15', y1: '15.5', x2: '111', y2: '15.5' }),
	      _react2.default.createElement('line', { className: 'st1', x1: '411', y1: '21', x2: '402', y2: '12' }),
	      _react2.default.createElement('line', { className: 'st1', x1: '336.5', y1: '16.5', x2: '348.5', y2: '16.5' }),
	      _react2.default.createElement('line', { className: 'st1', x1: '411', y1: '12', x2: '402', y2: '21' }),
	      _react2.default.createElement('rect', { x: '373', y: '12', className: 'st1', width: '6', height: '6' }),
	      _react2.default.createElement('rect', { x: '370', y: '15', className: 'st2', width: '6', height: '6' }),
	      _react2.default.createElement('g', null)
	    )
	  );
	};
	
	exports.default = Window;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e2a8c1f58a5d1d38050b.js